export const IMAGES = {
  hero: "https://customer-assets-lqy194kg.emergentagent.net/job_friendsgiving-guests/artifacts/w2lh19wk_image.png",
  og: "https://static.prod-images.emergentagent.com/jobs/661f29e3-a8cf-4456-924b-8623b33c6bcc/images/b38150287003b6b305d9e5a7617045b0e768489f99ab2cf46719620c58c1b42f.jpeg",
  toast: "https://static.prod-images.emergentagent.com/jobs/661f29e3-a8cf-4456-924b-8623b33c6bcc/images/a5d20820f607ada5ef603d266bd046dacbc7293c657b620dc2c35dda0b1367ce.jpeg",
  table1: "https://images.unsplash.com/photo-1536392706976-e486e2ba97af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  table2: "https://images.unsplash.com/photo-1625668931397-b9c35f63186b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  feast: "https://images.unsplash.com/photo-1574484184081-afea8a62f9c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spread: "https://images.unsplash.com/photo-1642112177610-c1ff271857dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const KARAOKE_CLIPS = [
  "/karaoke/clip1.mp4",
  "/karaoke/clip2.mp4",
];

export const DISH_CATEGORIES = [
  { id: "Main Dish", label: "Main Dish", icon: "🍗" },
  { id: "Side Dish", label: "Side Dish", icon: "🥘" },
  { id: "Salad", label: "Salad", icon: "🥗" },
  { id: "Appetizer / Bread", label: "Appetizer / Bread", icon: "🥖" },
  { id: "Dessert", label: "Dessert", icon: "🍰" },
  { id: "Drinks", label: "Drinks", icon: "🥤" },
  { id: "Other", label: "Other", icon: "🍽️" },
];

export const DIETARY_OPTIONS = ["Vegetarian", "Vegan", "Gluten-Free", "Food Allergy", "Other", "None"];

export const STATUS_LABELS = {
  attending: "Coming",
  declined: "Can't Make It",
  cancelled: "No Longer Attending",
};

export const formatPhone = (val) => {
  const d = (val || "").replace(/\D/g, "").slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
